module.exports = __webpack_public_path__ + "static/img/线下活动-展览展会.f64e6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-展览展会.png
// module id = AD1s
// module chunks = 1